import { UsersSelectionWidget, VehicleTypeSelectionWidget } from 'components/FormWidgets';

const uiSchema = (isSuperAdmin) => {
  const schema = {
    plaque: {
      'ui:options': {
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
        xl: 12,
      },
    },
  };

  if (isSuperAdmin) {
    schema.owner_ids = {
      'ui:widget': UsersSelectionWidget,
      'ui:options': {
        xs: 12,
        sm: 12,
        md: 6,
        lg: 6,
        xl: 6,
      },
    };
    schema.type_ids = {
      'ui:widget': VehicleTypeSelectionWidget,
      'ui:options': {
        xs: 12,
        sm: 12,
        md: 6,
        lg: 6,
        xl: 6,
      },
    };
  }

  return schema;
};

export default uiSchema;
